import React from "react";
import type { BoardCard } from "../types";
import { formatMinutes, formatCurrency } from "../lib/format";

interface Props {
  key?: import("../types").Id;
  card: BoardCard;
  onDragStart: (card: BoardCard) => void;
  onDragEnd: () => void;
  onOpen: (card: BoardCard) => void;
}

export default function KanbanCard({ card, onDragStart, onDragEnd, onOpen }: Props) {
  const isHot = card.temperature === "hot";
  const slaClass = card.sla?.status === "breach" ? "overdue" : card.sla?.status === "warning" ? "warning" : "";

  return (
    <div
      className="card"
      draggable
      onDragStart={(e: any) => {
        e.dataTransfer.setData("text/plain", card.id);
        onDragStart(card);
      }}
      onDragEnd={onDragEnd}
      onClick={() => onOpen(card)}
      title="Ver ficha 360°"
    >
      <div className="name">{card.contact_name}</div>
      <div className="meta">
        {card.service_name} · <span className="badge">{card.source_channel}</span>
      </div>
      <div className="row">
        <span className={`badge ${isHot ? "hot" : ""}`}>{isHot ? "🔥 Alta" : `◉ ${card.owner?.name || "Sin asignar"}`}</span>
        <span className="meta">{formatMinutes(card.time_in_stage_minutes)}</span>
      </div>
      <div className="row">
        <span className={`next-action ${slaClass}`}>{card.next_action_text || "Sin próxima acción"}</span>
      </div>
      <div className="row">
        <span className="meta">{formatCurrency(card.expected_value)}</span>
        {card.unread_count > 0 && <span className="badge unread">{card.unread_count}</span>}
      </div>
    </div>
  );
}
